import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
	selector: 'app-dob-picker',
	template: require('./dob-picker.component.html'),
	viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class DobPickerComponent implements OnInit {
	@Input() dob: Date;

	@Output() updateDob: EventEmitter<any> = new EventEmitter();

	currentYear = new Date().getFullYear();

	public days: number[] = this.getDays();

	public months: { name: string; value: number }[] = [
		{ name: 'Jan', value: 1 },
		{ name: 'Feb', value: 2 },
		{ name: 'Mar', value: 3 },
		{ name: 'Apr', value: 4 },
		{ name: 'May', value: 5 },
		{ name: 'Jun', value: 6 },
		{ name: 'Jul', value: 7 },
		{ name: 'Aug', value: 8 },
		{ name: 'Sep', value: 9 },
		{ name: 'Oct', value: 10 },
		{ name: 'Nov', value: 11 },
		{ name: 'Dec', value: 12 },
	];

	public years: number[] = this.getYears();

	public selectedDay: number;
	public selectedMonth: number;
	public selectedYear: number;

	private value: Date;

	constructor(public datepipe: DatePipe) {}

	ngOnInit() {
		if (this.dob) {
			const stringDate = this.datepipe.transform(this.dob, 'yyyy-MM-dd');
			this.selectedDay = +stringDate.slice(8, 10);
			this.selectedMonth = +stringDate.slice(5, 7);
			this.selectedYear = +stringDate.slice(0, 4);
		}
	}

	getDays(): number[] {
		let list = [];

		for (let i = 1; i <= 31; i++) {
			list.push(i);
		}
		return list;
	}

	getYears(): number[] {
		let list = []; // for users older than 18

		for (let i = this.currentYear - 100; i <= this.currentYear - 18; i++) {
			list.push(i);
		}
		return list.reverse();
	}

	updateValue() {
		if (this.selectedDay && this.selectedMonth && this.selectedYear && this.selectedDay > 0 && this.selectedMonth > 0 && this.selectedYear > 0) {
			const myDate = this.selectedYear + '/' + this.selectedMonth + '/' + this.selectedDay;
			this.value = new Date(myDate);
			this.updateDob.emit(this.value);
		} else {
			this.value = null;
			this.updateDob.emit(null);
		}
	}
}
